var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnPremise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(-4841 -2883)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    transform: "translate(45 459)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4841 2883)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4882 -3343)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 7)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 459.467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.39,12.467A2.106,2.106,0,0,0,0,13.684v5.5a2.153,2.153,0,0,0,2.15,2.151H13.533v3.78a2.341,2.341,0,0,0-1.82,1.82H.467a.467.467,0,1,0,0,.933H11.714a2.333,2.333,0,0,0,4.572,0H27.533a.467.467,0,1,0,0-.933H16.286a2.341,2.341,0,0,0-1.82-1.82v-3.78H25.85A2.153,2.153,0,0,0,28,19.183v-5.5a2.1,2.1,0,0,0-.39-1.217ZM4.9,18.533a2.1,2.1,0,1,1,2.1-2.1A2.1,2.1,0,0,1,4.9,18.533ZM15.4,27.4A1.4,1.4,0,1,1,14,26,1.4,1.4,0,0,1,15.4,27.4Zm.467-11.2a.467.467,0,1,1,.467-.467A.467.467,0,0,1,15.867,16.2Zm.933,1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,16.8,17.6Zm.933-1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,17.733,16.2Zm.933,1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,18.667,17.6Zm.933-1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,19.6,16.2Zm.933,1.4A.467.467,0,1,1,21,17.133.467.467,0,0,1,20.533,17.6Zm.933-1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,21.467,16.2Zm.933,1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,22.4,17.6Zm.933-1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,23.333,16.2Zm.933,1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,24.267,17.6Z",
    transform: "translate(0 -2.667)",
    fill: "#db8d25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.85.567H2.15A2.153,2.153,0,0,0,0,2.717v5.5A2.106,2.106,0,0,0,.39,9.433H27.61A2.1,2.1,0,0,0,28,8.216v-5.5A2.153,2.153,0,0,0,25.85.567Zm-20.95,7A2.1,2.1,0,1,1,7,5.467,2.1,2.1,0,0,1,4.9,7.567ZM15.867,5.233a.467.467,0,1,1,.467-.467A.467.467,0,0,1,15.867,5.233Zm.933,1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,16.8,6.633Zm.933-1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,17.733,5.233Zm.933,1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,18.667,6.633Zm.933-1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,19.6,5.233Zm.933,1.4A.467.467,0,1,1,21,6.167.467.467,0,0,1,20.533,6.633Zm.933-1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,21.467,5.233Zm.933,1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,22.4,6.633Zm.933-1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,23.333,5.233Zm.933,1.4a.467.467,0,1,1,.467-.467A.467.467,0,0,1,24.267,6.633Z",
    transform: "translate(0 -0.567)",
    fill: "#db8d25"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnPremise);
export default __webpack_public_path__ + "static/media/onPremise.4537222c89cd74e22ac76ebd5fd60e04.svg";
export { ForwardRef as ReactComponent };